import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileSearch } from "lucide-react";
import { ImportarRoteiro } from "@/pages/MotorCredito";

export default function ImportarRoteiroDialog({ bancoId, bancoNome, onSaved }) {
  const [open, setOpen] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [orgaos, setOrgaos] = useState([]);

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/bancos`).then((r) => setBancos(r.data || [])).catch(() => {});
    axios.get(`${API}/lookup/instituicoes`).then((r) => setOrgaos((r.data?.instituicoes || []).map((s) => ({ id: s, nome: s })))).catch(() => {});
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="gap-2 border-indigo-500 text-indigo-600 hover:bg-indigo-50" data-testid="btn-importar-roteiro-pdf">
          <FileSearch className="h-4 w-4" /> Importar Roteiro PDF
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileSearch className="h-5 w-5 text-indigo-600" /> Importar Roteiro Operacional (PDF)
          </DialogTitle>
        </DialogHeader>
        <ImportarRoteiro
          bancos={bancos}
          orgaos={orgaos}
          fixedBancoId={bancoId}
          fixedBancoNome={bancoNome}
          onSaved={() => { if (onSaved) onSaved(); setOpen(false); }}
        />
      </DialogContent>
    </Dialog>
  );
}
